import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Processing from '../Processing/Processing'

import styles from './Table.css'

const propTypes = {
    children: PropTypes.node.isRequired,
    processingCaption: PropTypes.node,
    isScrollable: PropTypes.bool,
    isProcessing: PropTypes.bool,
}

/**
 * @example ./Table.components.md
 */

const Table = (props) => {

    const processingLocal = props.isProcessing ? (
        <Processing
            type="local"
            caption={props.processingCaption}
            isVisible
        />
    ) : null

    const classNameTable = classNames(styles.table, {
        [styles.isScrollable]: props.isScrollable,
        [styles.isProcessing]: props.isProcessing,
    })

    return(
        <div className={styles.base}>
            {processingLocal}
            <div className={classNameTable}>{props.children}</div>
        </div>
    )
}

Table.propTypes = propTypes

export default Table



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/Table/Table.jsx